<template>
  <div class="b-refund-form__wrapper">
    <form
      @submit="formSubmit"
      method="POST"
      class="b-form"
    >
      <div class="b-form__group">
        <label for="email"
          >Enter your AdTranquility customer email</label
        >
        <input
          type="email"
          name="email"
          id="email"
          placeholder="yourname@gmail.com"
          v-model.trim="$v.email.$model"
          class="b-form__control"
          :class="{error: $v.email.$error}"
        />
        <div class="b-form__control-error text-danger" v-if="!$v.email.required">
          Email is required
        </div>
      </div>
      <button
        class="b-button b-button--primary"
        type="submit"
      >
        Cancel and refund
      </button>
    </form>
    <div class="alert alert-danger" v-if="submitStatus == $options.VALIDATION_ERROR">
      Please update the missing fields before submitting your request.
    </div>
    <div class="alert alert-success" v-if="submitStatus == $options.OK">
      Your subscription is now cancelled and your refund is on its way.
      The refund will reach your bank in 10-15 days, depending on your bank.
      For any questions concerning your subscription status, please contact
      <a href="mailto:support@adtranquility.com">support@adtranquility.com</a>
    </div>
    <div class="alert alert-warning" v-if="submitStatus == $options.MISSPELLED">
      The email provided was not located in our Customer database. Please check your spelling or
      refer to this
      <a href="https://adtranquility.zendesk.com/hc/en-us/articles/6551940291474--Android-Identify-the-Email-Address-You-Subscribed-With" target="_blank">article</a>
      to determine the correct email used to subscribe.
    </div>
    <div class="alert alert-danger" v-if="submitStatus == $options.NOTFOUND">
      There's <b>0</b> users with this email in our <b>customer base</b>.
      Please contact <a href="mailto:support@adtranquility.com">support@adtranquility.com</a>
      to help you locate your subscription.
    </div>
    <div class="alert alert-primary" v-if="submitStatus == $options.PENDING">
      Please wait, sending.
    </div>
    <div class="alert alert-danger" v-if="submitStatus == $options.ERROR">
      Form error. Try to reload the page and submit again.
    </div>
    <div class="alert alert-danger" v-if="submitStatus == $options.PREVIOUSLY_CANCELED">
      Your subscription <b>was cancelled on {{ readableCancellationDate }}</b>
      and should <b>reach</b> your <b>bank in 10-15 days</b>.
      If it's already been 15 days, please <b>contact your bank</b>.
      For any questions or concerns regarding your <b>subscription status</b>,
      please contact <a href="mailto:support@adtranquility.com">support@adtranquility.com</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import {
  required,
  email,
} from 'vuelidate/lib/validators';

export default {
  name: 'RefundForm',
  ERROR: 'error',
  VALIDATION_ERROR: 'validation_error',
  OK: 'ok',
  PENDING: 'pending',
  MISSPELLED: 'misspelled',
  NOTFOUND: 'not_found',
  PREVIOUSLY_CANCELED: 'previously_canceled',
  data() {
    return {
      email: '',
      submitStatus: null,
      submitAttempts: 0,
      customerFound: false,
      latestCanceledSubscriptionDate: null,
    };
  },
  computed: {
    readableCancellationDate() {
      console.log(this.latestCanceledSubscriptionDate);
      if (this.latestCanceledSubscriptionDate) {
        const rd = moment.unix(this.latestCanceledSubscriptionDate).format('MM/DD/YYYY');
        return rd;
      }
      return 'recently';
    },
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();
      if ((this.submitStatus === this.$options.PENDING) || this.submitAttempts >= 3) return;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = this.$options.VALIDATION_ERROR;
      } else {
        this.submitStatus = this.$options.PENDING;
        axios.post('https://api.adtranquility.com/api/v1/refund/', {
          email: this.email,
        })
          .then((response) => {
            console.log(response);
            this.submitAttempts += 1;
            if (response.data.result === 'BAD PAYLOAD') {
              this.submitStatus = this.$options.ERROR;
            }
            if (response.data.result === 'NOT FOUND') {
              if (!response.data.stripeCustomersFound) {
                this.submitStatus = this.submitAttempts < 3
                  ? this.$options.MISSPELLED
                  : this.$options.NOTFOUND;
              } else {
                this.customerFound = true;
                this.latestCanceledSubscriptionDate = response.data.latestCancelledSubscriptionDate
                || 0;

                this.submitStatus = this.$options.PREVIOUSLY_CANCELED;
              }
            }
            if (response.data.result === 'OK') {
              this.submitStatus = this.$options.OK;
              this.$v.$reset();
              this.email = '';
            }
          })
          .catch((err) => {
            console.log(err);
            this.submitStatus = this.$options.ERROR;
          });
      }
    },
  },
  validations: {
    email: {
      email,
      required,
    },
  },
};
</script>
